import { FormControl, FormGroup, Validators } from '@angular/forms';
import { emailValidator } from '../../../validators/email.validator';
import { passwordValidator } from '../../../validators/password.validator';
import { fieldMatchValidator } from '../../../validators/field-match.validator';
import { AUTH_PASSWORD_VALIDATOR_OPTS } from './auth-password-validator-opts';

export type ResetPasswordFormGroup = FormGroup<{
  email: FormControl<string>;
  code: FormControl<string>;
  newPassword: FormControl<string>;
  confirmPassword: FormControl<string>;
}>;

export function createResetPasswordFormGroup(): ResetPasswordFormGroup {
  return new FormGroup(
    {
      email: new FormControl<string>(
        { value: '', disabled: true },
        {
          nonNullable: true,
          validators: [Validators.required, emailValidator]
        }
      ),
      code: new FormControl<string>(
        { value: '', disabled: true },
        {
          nonNullable: true,
          validators: [Validators.required]
        }
      ),
      newPassword: new FormControl<string>('', {
        nonNullable: true,
        validators: [Validators.required, passwordValidator(AUTH_PASSWORD_VALIDATOR_OPTS)]
      }),
      confirmPassword: new FormControl<string>('', {
        nonNullable: true,
        validators: [Validators.required]
      })
    },
    { validators: fieldMatchValidator('newPassword', 'confirmPassword', 'passwordsMustMatch') }
  );
}
